// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.restrictions.RentalManagerUserPropertyRestrictionsWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyRestrictionsWebApiHandler_get,
  RentalManagerUserPropertyRestrictionsWebApiHandler_get_Path,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type { ListingAlias, RentalManagerListingRestrictionsDto } from '@zg-rentals/ts-rental-manager-api-beta-client';

interface GetParams {
  listingAlias: ListingAlias;
}

export type RentalManagerUserPropertyRestrictionsWebApiHandler_get_Options = UseQueryOptions<
  RentalManagerListingRestrictionsDto,
  unknown,
  RentalManagerListingRestrictionsDto,
  readonly [string, GetParams]
>;

const RentalManagerUserPropertyRestrictionsWebApiHandler_get_GetKey = (getParams: GetParams) =>
  [RentalManagerUserPropertyRestrictionsWebApiHandler_get_Path, getParams] as const;

export const RentalManagerUserPropertyRestrictionsWebApiHandler_get_queryOptions = (
  getParams: GetParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyRestrictionsWebApiHandler_get_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyRestrictionsWebApiHandler_get(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get restrictions for a given listing
 */
export const useRentalManagerUserPropertyRestrictionsWebApiHandler_get = (
  getParams: GetParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyRestrictionsWebApiHandler_get_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyRestrictionsWebApiHandler_get_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyRestrictionsWebApiHandler_get.getKey =
  RentalManagerUserPropertyRestrictionsWebApiHandler_get_GetKey;
